import * as Sentry from '@sentry/react';

import { Hub, LoginContext } from '@aslanpay/portal-common-lib';

/**
 * Reports a failed Cognito hosted UI (SSO) code exchange to Sentry. Amplify handles the ?code=
 * during configure and announces a failure once; the lazy-loaded SSOCallback page can mount after
 * that, so this must be registered before Amplify is configured or the real reason is lost.
 */
export const reportHostedUiFailures = (ssoContext: LoginContext) =>
  Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'cognitoHostedUI_failure') {
      Sentry.captureException(payload.data, { tags: { flow: 'sso-callback', ssoContext } });
    }
  });
